<template>
  <div class="live-lottery-list">
    <div class="lottery_create" v-show="!noData">
      <vh-button type="primary" round @click="createLottery">{{ $t('host.k_564001') }}</vh-button>
      <vh-input
        v-model.trim="keyword"
        :placeholder="$t('host.k_564002')"
        clearable
        @keyup.enter.native="handleSearch"
        style="width: 220px"
        @clear="handleSearch"
      >
        <i
          slot="prefix"
          class="vh-icon-search vh-input__icon"
          style="cursor: pointer; line-height: 36px"
          @click="handleSearch"
        ></i>
      </vh-input>
    </div>
    <div class="lottery_list">
      <vh-table :data="lotteryList" style="width: 100%" height="350" v-show="!noData">
        <!-- 无数据展示 -->
        <template slot="empty">
          <div v-if="isLoading" v-loading="isLoading"></div>
          <div v-else>
            <img src="@/app-shared/assets/img/no-search.png" />
            <p>{{ $t('host.k_564003') }}</p>
          </div>
        </template>
        <!-- 有数据表格 -->
        <vh-table-column
          prop="title"
          :label="$t('host.k_564004')"
          :show-overflow-tooltip="true"
          fixed="left"
          min-width="140"
        ></vh-table-column>
        <vh-table-column prop="quantity" :label="$t('host.k_564005')" width="80"></vh-table-column>
        <vh-table-column prop="lottery_type_name" :label="$t('host.k_564006')" width="120">
          <template slot-scope="scope">
            <span>
              {{ lotteryTypeName(scope.row) }}
            </span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_564007')" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.has_winning_range == 1 ? $t('host.k_564008') : $t('host.k_564009') }}
            </span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_564010')" width="80">
          <template slot-scope="scope">
            <span class="lottery_blue" @click="goLookWinning(scope.row.lottery_id)">
              {{ scope.row.winners_num }}
            </span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_564011')" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.lottery_status > 0">
              {{ scope.row.lottery_status == 1 ? $t('host.k_564012') : $t('host.k_564013') }}
            </span>
            <span class="lottery_red" v-else>
              {{ $t('host.k_564014') }} ({{ formatDuration(scope.row) }})
            </span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_564015')" width="100">
          <template slot-scope="scope">
            <span>
              {{ scope.row.lottery_method == 1 ? $t('host.k_564016') : $t('host.k_564017') }}
            </span>
          </template>
        </vh-table-column>
        <vh-table-column :label="$t('host.k_564018')" fixed="right" align="left" width="180">
          <template slot-scope="scope">
            <vh-button
              type="text"
              v-if="scope.row.lottery_status > 0"
              @click="publishLottery(scope.row.lottery_id)"
              :disabled="scope.row.lottery_status == 1"
              v-preventReClick
            >
              {{ $t('host.k_564019') }}
            </vh-button>
            <vh-button
              type="text"
              v-preventReClick
              v-if="scope.row.lottery_status == 0"
              :disabled="lotteryTime < 5"
              @click="endLottery(scope.row.lottery_id)"
            >
              {{ $t('host.k_564020') }}
            </vh-button>
            <vh-button type="text" @click="copeLottery(scope.row.lottery_id)">
              {{ $t('host.k_564021') }}
            </vh-button>
            <vh-button
              type="text"
              v-preventReClick
              @click="
                editLottery(scope.row.lottery_id, scope.row.lottery_status != 2 ? 'view' : 'edit')
              "
            >
              {{ scope.row.lottery_status != 2 ? $t('host.k_603007') : $t('host.k_564022') }}
            </vh-button>
            <vh-button
              type="text"
              plain
              :disabled="scope.row.lottery_status == 0"
              v-preventReClick
              @click="deleteLottery(scope.row)"
            >
              {{ $t('host.k_564023') }}
            </vh-button>
          </template>
        </vh-table-column>
      </vh-table>
      <div class="no-lottery" v-show="noData">
        <img src="../../img/no-file.png" alt="" />
        <p>{{ $t('host.k_564024') }}</p>
        <p>
          <vh-button type="primary" round @click="createLottery">
            {{ $t('host.k_564001') }}
          </vh-button>
        </p>
      </div>
    </div>
    <div class="lottery_pagination" v-show="total > pageInfo.limit">
      <vh-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageInfo.limit"
        :current-page="pageInfo.pageNum"
        @current-change="currentChangeHandler"
      ></vh-pagination>
    </div>
    <lottery-winner ref="lotteryWin" />
  </div>
</template>
<script>
  import listMixin from '../mixins/list.js';

  export default {
    mixins: [listMixin],
    methods: {
      // 创建抽奖
      createLottery() {
        this.lotteryServer.recordLotteryInfo();
        this.$emit('returnStep', 'create');
      },
      // 编辑抽奖
      editLottery(id, type) {
        this.lotteryServer.recordLotteryInfo(id);
        this.$emit('returnStep', type);
      },
      // 分页
      currentChangeHandler(current) {
        this.pageInfo.pageNum = current;
        this.getLotteryList();
      }
    }
  };
</script>
<style lang="less">
  .live-lottery-list {
    .lottery_create {
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;
      .vh-input__inner {
        border-radius: 20px;
        line-height: 36px;
        height: 36px;
      }
    }
    .lottery_list {
      height: 360px;
      color: #1a1a1a;
      .vh-table {
        .vh-table__body-wrapper {
          overflow-y: auto;
          height: 100%;
        }
        td:last-child {
          padding-right: 0;
        }
        td:first-child {
          padding-left: 12px !important;
        }
      }
      .lottery_blue {
        color: #3562fa;
        cursor: pointer;
      }
      .lottery_red {
        color: #fb3a32;
      }
      .no-lottery {
        text-align: center;
        margin-top: 70px;
        p {
          margin-top: 12px;
        }
      }
    }
    // .vh-button {
    //   &:hover {
    //     color: #1a1a1a;
    //   }
    // }
    .vh-button--text {
      color: #1a1a1a;
    }
    .vh-button.is-round {
      padding: 7px 21px;
    }
    .vh-button + .vh-button {
      margin-left: 10px;
    }
    .vh-button.is-disabled {
      color: rgba(0, 0, 0, 0.55);
      &:hover {
        cursor: not-allowed;
      }
    }
    .lottery_pagination {
      text-align: center;
      padding-top: 24px;
      .vh-pagination.is-background .vh-pager li {
        color: #595959;
        &:hover {
          color: #fb3a32;
        }
        &:not(.disabled).active {
          background-color: #fb3a32;
          color: #fff;
        }
      }
    }
  }
</style>
